import * as React from 'react';
/**
 * Question Mark help SVG
 *
 * @returns
 */
function HelpSVG(svgProps: SVGProps) {
	return (
		<svg
			viewBox="0 0 32 32"
			className={'icon icon-help-header ' + svgProps.class}
			focusable="false"
			aria-hidden="true"
		>
			<path d="M16 0c-8.837 0-16 7.163-16 16s7.163 16 16 16c8.837 0 16-7.163 16-16v0c0-8.837-7.163-16-16-16v0zM15.748 25.333h-0.085c-1.222-0.015-2.207-1.009-2.207-2.233 0-1.234 1-2.233 2.233-2.233 0.009 0 0.019 0 0.028 0h0.075c1.223 0.013 2.209 1.007 2.209 2.232 0 1.233-0.999 2.232-2.232 2.232-0.008 0-0.016-0-0.024-0h0.001zM21.233 14.448c-0.54 0.614-1.141 1.153-1.798 1.617l-0.032 0.022-0.933 0.645c-0.414 0.282-0.736 0.672-0.927 1.13l-0.006 0.017c-0.095 0.244-0.149 0.527-0.149 0.823 0 0.048 0.001 0.096 0.004 0.143l-0-0.007v0.151h-3.583l0.009-0.303c-0.018-0.14-0.028-0.302-0.028-0.467 0-0.784 0.23-1.515 0.627-2.128l-0.009 0.015c0.788-0.795 1.661-1.502 2.606-2.109l0.061-0.037c0.246-0.181 0.455-0.394 0.626-0.637l0.006-0.009c0.306-0.356 0.504-0.813 0.54-1.314l0-0.007c0-0.005 0-0.011 0-0.017 0-0.567-0.183-1.091-0.493-1.517l0.005 0.007c-0.375-0.419-0.917-0.682-1.521-0.682-0.087 0-0.173 0.005-0.257 0.016l0.010-0.001c-0.060-0.007-0.129-0.010-0.199-0.010-0.656 0-1.236 0.329-1.583 0.831l-0.004 0.006c-0.334 0.501-0.535 1.116-0.541 1.777v0.155h-3.685l0.007-0.16c-0.003-0.070-0.005-0.152-0.005-0.235 0-1.894 0.94-3.568 2.379-4.582l0.018-0.012c0.932-0.571 2.061-0.91 3.269-0.91 0.070 0 0.139 0.001 0.208 0.003l-0.010-0c0.080-0.003 0.173-0.005 0.268-0.005 1.569 0 3.025 0.483 4.229 1.308l-0.026-0.017c1.108 0.821 1.818 2.124 1.818 3.593 0 0.091-0.003 0.181-0.008 0.271l0.001-0.012c-0.005 0.997-0.339 1.915-0.899 2.652l0.008-0.011z" />
		</svg>
	);
}

HelpSVG.defaultProps = { class: '' };

export default HelpSVG;
